import * as RadixDialog from '@radix-ui/react-dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import styles from './styles.module.scss';

type GameEndDialog = {
  result: 'fail' | 'success';
  onRetry: () => void;
  onConfirm: () => void;
  portalContainer?: HTMLElement | null;
  contentProps?: RadixDialog.DialogContentProps;
} & RadixDialog.DialogProps;

export default function GameEndDialog({
  result,
  onRetry,
  onConfirm,
  portalContainer,
  contentProps,
  ...props
}: GameEndDialog) {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLButtonElement>) => {
    if (event.key === ' ' || event.key === 'Space') {
      event.preventDefault();
    }
  };

  return (
    <RadixDialog.Root {...props}>
      <RadixDialog.Portal container={portalContainer}>
        <RadixDialog.Content
          {...contentProps}
          className={`dialog-content-centered ${contentProps?.className || ''}`}
        >
          <VisuallyHidden>
            <RadixDialog.Title />
          </VisuallyHidden>
          <img
            src={
              result === 'fail'
                ? 'https://asthma-staging-public-storage.s3.ca-central-1.amazonaws.com/asthma-trigger/game/failScreenBackground.png'
                : 'https://asthma-staging-public-storage.s3.ca-central-1.amazonaws.com/asthma-trigger/game/missionSuccessBackground.png'
            }
            alt={`${result} screen background`}
            className={styles.image}
          />
          <div className={styles.buttonContainer}>
            <button
              className={styles.button}
              onClick={onRetry}
              onKeyDown={handleKeyDown}
            >
              <img
                src="https://asthma-staging-public-storage.s3.ca-central-1.amazonaws.com/asthma-trigger/game/retryButton.png"
                alt="Retry"
                className={styles.buttonImage}
              />
            </button>
            <button
              className={styles.button}
              onClick={onConfirm}
              onKeyDown={handleKeyDown}
            >
              <img
                src="https://asthma-staging-public-storage.s3.ca-central-1.amazonaws.com/asthma-trigger/game/continueButton.png"
                alt="Continue"
                className={styles.buttonImage}
              />
            </button>
          </div>
        </RadixDialog.Content>
      </RadixDialog.Portal>
    </RadixDialog.Root>
  );
}
